import React from 'react'
import { Link } from 'react-router-dom';
import { withRouter } from "react-router";


const MainAnchorMenu = (props) =>
{
    if(props.siteProperties) {
        var menu_items = props.siteProperties.data.main_menu;

        var anchors= [];
        if(props.element && props.element.data['parts']){
            props.element.data['parts'].forEach(part => {
                if(part['anchor'] !== ''){
                    anchors[part['name']] = part['anchor'];
                }
            })
        }
        return (
            <div className="anchors flex">
            {
                Object.keys(anchors).length > 0 && (
                    Object.keys(anchors).map(value => (
                        <div className="anchors__item" key={`anchor${anchors[value]}`}>
                            <a className="scroll-raffle" href={`#${anchors[value]}`}>
                                {value}
                            </a>
                        </div>
                    ))
                )
            }
            {
                menu_items.map(item => {
                    let link = `/${item['seo']['folder']}`;
                    let target = '';

                    if (item['seo']['folder'] === 'home/' || item['seo']['folder'] === 'home') {
                        link = "/";
                    }

                    if (item['external_link'] !== '') {
                        target = 'target="_blank"';
                        link = item['external_link'];
                    }
                    if(link ==='/' && (props.location.pathname === "/" || props.location.pathname === "/inicio")) {
                        return null
                    }
                    return (
                        <div className="anchors__item" key={`menu-items${item.sort}`}>
                            <Link to={link} {...target}>
                                { item['name'] }
                            </Link>
                        </div>
                    )
                })
            }
            </div>
        )
    } else {
        return null
    }
}

export default withRouter(MainAnchorMenu);